type StaticSearchQuery = {
  name: string;
  href: string;
};

export const StaticSearchQueries: StaticSearchQuery[] = [
  {
    name: 'Frontend in 2025: Trends Shaping Development',
    href: 'https://jsdev.space/frontend-trends-2025/',
  },
  {
    name: '20 TypeScript Tips for Cleaner, More Efficient Code',
    href: 'https://jsdev.space/20-ts-tricks/',
  },
  {
    name: 'Top JavaScript Frameworks and Libraries to Watch in 2025',
    href: 'https://jsdev.space/js-frameworks-libs/',
  },
  {
    name: 'Create Stunning Maps Effortlessly - Master React Leaflet',
    href: 'https://jsdev.space/mastering-react-leaflet/'
  },
  {
    name: 'Build a Classic Snake Game from Scratch with Pure JavaScript!',
    href: 'https://jsdev.space/snake-js/'
  }
];
